import React from 'react';
import checkbanque from './../../../../../assets/images/svg/060-bank-check.svg';
import {Card} from './card';
import {BankAccountType} from '../../../../../constants/models/servicePayloads/bankAccountType';

export const Placement = ({branch, isMain, globalPayload, setGlobalPayload}) => {
    const cardTypes = [BankAccountType.LivretA, BankAccountType.Ldds, BankAccountType.Lep, BankAccountType.LivretJeune, BankAccountType.Cel,
        BankAccountType.Pel, BankAccountType.Perp, BankAccountType.LivretEpargneBancaire, BankAccountType.Cat,  BankAccountType.CoffreFortBancaire,
        BankAccountType.Scpi, BankAccountType.Pea, BankAccountType.CompteTitre, BankAccountType.Opcvm
    ];

    return (
        <div className="grid grid-md-min grid-lg-tight grid-lg-4">
            {
                cardTypes.map((name, index) => {
                    return <Card key={index} cardType={name} icon={checkbanque} branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload}/>
                })
            }
            {/* <PasService icon={checkbanque} cardType={BankAccountType.PasPlacements}/> */}
        </div>
    );
}